import { Action, createReducer, on } from '@ngrx/store';
import * as fromActions from '../actions';
import { FetchArgs } from 'src/app/shared/models/core';
import { ExpertiseModel } from 'src/app/shared/models/expertisemodel.model';
import { ImportMarginGridData } from 'src/app/recruiting/direct-offer-margin/direct-offer-Import-margin-grid-data.model';

const initialGridState = (): FetchArgs => ({
    sort: { field: 'createdDate', dir: 'desc' },
    skip: 0,
    pageSize: 25
});

export interface DirectOfferImportMarginsState {
    isLoading: boolean;
    margins: ImportMarginGridData[];
    expertiseList: ExpertiseModel[];
    searchQuery: FetchArgs;
    error: unknown;
    marginId: number;
}

export const initialDirectOfferImportMarginsState: DirectOfferImportMarginsState = {
    isLoading: false,
    margins: null,
    expertiseList: null,
    searchQuery: initialGridState(),
    error: undefined,
    marginId: undefined
};

export function directOfferImportMarginsReducer(state: DirectOfferImportMarginsState, action: Action) {
    return createReducer(
        initialDirectOfferImportMarginsState,
        on(fromActions.RecruitingActions.DirectOfferImportMarginActions.loadMargins, (state) => ({
            ...state,
            isLoading: true
        })),

        on(fromActions.RecruitingActions.DirectOfferImportMarginActions.loadMarginsSuccess, (state, action) => ({
            ...state,
            isLoading: false,
            margins: action.margins
        })),

        on(fromActions.RecruitingActions.DirectOfferImportMarginActions.loadMarginsLookups, (state) => ({
            ...state,
            isLoading: true
        })),

        on(fromActions.RecruitingActions.DirectOfferImportMarginActions.loadMarginsLookupsSuccess, (state, action) => ({
            ...state,
            isLoading: false,
            expertiseList: action.expertiseList
        })),

        on(
            fromActions.RecruitingActions.DirectOfferImportMarginActions.loadMarginsLookupsFailure,
            fromActions.RecruitingActions.DirectOfferImportMarginActions.loadMarginsFailure,
            (state, action) => ({
                ...state,
                isLoading: false,
                error: action.error
            })
        ),

        on(fromActions.RecruitingActions.DirectOfferImportMarginActions.setMarginsGridSearchQuery, (state, action) => ({
            ...state,
            searchQuery: action.searchQuery,
            isLoading: true
        })),

        on(fromActions.RecruitingActions.DirectOfferImportMarginActions.createDirectOfferMarginViaImport, (state) => ({
            ...state,
            isLoading: true
        })),

        on(
            fromActions.RecruitingActions.DirectOfferImportMarginActions.createDirectOfferMarginViaImportSuccess,
            (state, action) => ({
                ...state,
                isLoading: false,
                marginId: action.marginId
            })
        ),

        on(
            fromActions.RecruitingActions.DirectOfferImportMarginActions.createDirectOfferMarginViaImportFailure,
            (state, action) => ({
                ...state,
                isLoading: false,
                error: action.error
            })
        ),

        on(fromActions.RecruitingActions.DirectOfferImportMarginActions.resetMarginId, (state, action) => ({
            ...state,
            marginId: action.marginId,
            isLoading: false
        }))
    )(state, action);
}

export function reducer(state: DirectOfferImportMarginsState | undefined, action: Action) {
    return directOfferImportMarginsReducer(state, action);
}
